import Vue from 'vue'
// import abilityDefinerForRouting from './ability'

export const canNavigate = async to => {
  const ab = Vue.prototype.$ability
  return to.matched.some(route => ab.can(route.meta.action || 'read', route.meta.resource))
}
export const _ = undefined
